<section class="w-100 float-left portfolio_section">
    <div class="container">
        <div class="main_title d-flex justify-content-center" >
            <h1 class="line"><span>Our</span> Portfolio </h1>
        </div>
        <h2 class="sub_title text-center w-100 float-left" >Here is a glimpse of our work that says the story of our focused approach and dedicated efforts to meet the client’s business requirements.</h2>
        <div class="w-100 float-left">
            <div class="row mt-4" *ngIf="portFolios">
                <div *ngFor="let portfolio of portFolios" class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-6">
                    <div class="portfolio_box mb-3 w-100 float-left">
                        <div class="portfolio_box_hover_box">
                                {{portfolio.industry}}
                        </div>
                        <img [src]="portfolio.feature_image" alt="Portfolio img">
                        <div class="portfolio_box_title">{{portfolio.title}}</div>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left d-flex justify-content-center"
                >
                <button class="main_btn text-uppercase mt-4" routerLink="/portfolios">View More</button>
            </div>
        </div>
    </div>
</section>